import * as React from 'react'
import { FormValue, FileTextValue } from '../../reducers/form-values'
import { inputValueChangeFn } from './form-type-selector'
import { nl2br, targetBlankifyLinks } from '../utils'
import { strings } from '../localization'
import { errorMsg } from './build-error-msg'

export function buildStarRating (data, value: FileTextValue, inputValueChange: inputValueChangeFn) {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    inputValueChange(data.qid, 'textInput', e.target.value)
  }
  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>, rating: string) => {
    if (e.key === ' ') {
      e.preventDefault()
      inputValueChange(data.qid, 'textInput', rating)
    }
  }

  const labelHtml = {
    __html: nl2br(targetBlankifyLinks(data.label))
  }

  const labelId = `radio-group-${data.qid}`

  return (
    <div className={data.className ? data.className : 'col-xs-12'} key={data.qid}>
      <div
        className={'input-line input-rating'}
        role='radiogroup'
        aria-required={data.required}
        aria-labelledby={labelId}
      >
      {data.label && <label>
        <span id={labelId} dangerouslySetInnerHTML={labelHtml}></span>
         <span className='fieldRequired'>{data.required && '*'}</span></label>}
      <div className='npsRatingContent'>
        {[ 10, 9, 8, 7, 6, 5, 4, 3, 2, 1 ].map((nr: number) => [
          <input
              key={'radio' + nr}
              type='radio'
              id={`stars-${data.qid}-${nr}`}
              name={`rating-${data.qid}`}
              onChange={onChange}
              value={nr}
              checked={value.value === String(nr)} />,
          <label
            key={'label' + nr}
            className={nr % 2 !== 0 ? 'half' : 'full'}
            htmlFor={`stars-${data.qid}-${nr}`}
            role='radio'
            aria-label={strings.formatString(strings.a11yRadioStar, { number: nr }) as string}
            aria-checked={value.value === String(nr)}
            tabIndex={0}
            onKeyDown={(e) => handleKeyDown(e, String(nr))}
            ></label>
        ])}
      </div>
      {data.errorMessage &&
        errorMsg(data.qid, data.errorMessage)}
    </div></div>

  )
}
